import Link from 'next/link';
import React from 'react';

interface StyledLinkPropsInterface {
    children: React.ReactNode;
    iconPrefix?: React.ReactNode;
    iconSuffix?: React.ReactNode;
    href?: string;
    onClick?: () => void;
}

export const StyledLink: React.FC<StyledLinkPropsInterface> = ({
    children,
    href = '#',
    iconPrefix,
    iconSuffix,
    onClick,
}) => {
    if (onClick) {
        return (
            <a
                className="inline-flex cursor-pointer items-center text-brand-primary no-underline hover:underline"
                onClick={onClick}
            >
                {children}
            </a>
        );
    }

    return (
        <Link href={href}>
            <a className="inline-flex cursor-pointer items-center text-brand-primary no-underline hover:underline">
                {iconPrefix && <span className="mr-vsmall">{iconPrefix}</span>}
                {children}
                {iconSuffix && <span className="ml-vsmall">{iconSuffix}</span>}
            </a>
        </Link>
    );
};
